import React, { useEffect, useState } from "react";
import { Button, Typography, styled } from "@mui/material";
import { GetDataFromLocalStorage } from "../utils/storeAndGetDataFromLocalStorage";
import ResultScreen from "./ResultScreen";
import {
  BACK_BUTTON,
  HEADER_TEXT,
  SELECT_ALL_THAT_APPLY_TITLE,
  SKIP_NEXT_BUTTON,
} from "../utils/constants";

const StyledButton = styled(Button)(({ theme, selected }) => ({
  backgroundColor: "#fff",
  color: "#000",
  cursor: "pointer",
  fontWeight: "600",
  fontSize: "1em",
  minWidth: "148px",
  margin: "12px 10px",
  boxShadow: selected ? "inset 0 0 0 3px #333" : "none",
  padding: "35px",
  height: "70px",
  "&:hover": {
    background: "#fff",
    boxShadow: "inset 0 0 0 3px #000",
  },
}));

function QuestionScreen(props) {
  const { data, handleNextQuestion, handlePreviousQuestion, endQuiz } = props;

  const hideBackButton = GetDataFromLocalStorage("shouldHideBackButton");

  const {
    to_pass: { current_question },
    to_use: { next_choices, multichoice, skus, gray_map, skippable },
  } = data;

  const disableAnswerBasedOnSelectedAnswer = Object.fromEntries(gray_map);

  // reset the state when new questions come.
  useEffect(() => {
    setMultiSelectAnswer([]);
    setSingleChoiceAnswer("");
  }, [data]);

  const [multiSelectAnswer, setMultiSelectAnswer] = useState([]);
  const [singleChoiceAnswer, setSingleChoiceAnswer] = useState("");

  const handleBackClick = () => {
    //check that last question was skipped based on the saved answer list.
    // if the saved answer list's last value is skipped that means last question was skipped.
    let previousQuestionPayload = GetDataFromLocalStorage(
      "previousQuestionPayload"
    );

    handlePreviousQuestion(previousQuestionPayload);

    //clear the multiselect list on next/back click.
    setMultiSelectAnswer([]);
  };

  const handleAnswerButtonClick = (data) => {
    // if multiselect ans question, then store the selected ans in the list else provide next question when user click on single choice question's answer.
    if (!!multichoice) {
      //if user selected the already selected option, then unselect that option.
      if (multiSelectAnswer?.some((ans) => ans === data)) {
        setMultiSelectAnswer(multiSelectAnswer.filter((ans) => ans !== data));
      } else {
        setMultiSelectAnswer([...multiSelectAnswer, data]);
      }
    } else {
      setSingleChoiceAnswer(data);
      handleNextQuestion(data);
    }
  };

  // when user click on the next button (after selecting multiple choices) or skip button.
  const handleNextSkipClick = () => {
    // if length is available then multiselect else user skip the question.
    if (multiSelectAnswer.length) {
      handleNextQuestion(multiSelectAnswer);
    } else {
      handleNextQuestion("Skipped");
    }
  };

  // disable all the answer button when user selected 2 answer.
  const shouldDisableAnswersButton = (answer) => {
    // disable the same answer options based on the selected answer
    const disableAnswerList =
      disableAnswerBasedOnSelectedAnswer[multiSelectAnswer[0]];
    // if 2 answer selected then disable all other options except selected answer,
    // else disable the same answer option if any for selected answer.
    if (multiSelectAnswer.length > 1 && !multiSelectAnswer.includes(answer)) {
      return true;
    } else {
      return disableAnswerList?.includes(answer) || false;
    }
  };

  return (
    <>
      {skus.length ? (
        <div className="w-100">
          <ResultScreen
            products={JSON.parse(skus)}
            endQuiz={endQuiz}
            filters={current_question}
            quizData={data}
          />
        </div>
      ) : (
        <div className="d-flex flex-column justify-content-center align-items-center py-5 bg-image">
          <div className="mb-3 text-uppercase fw-normal">{HEADER_TEXT}</div>
          <div className="question" id="question">
            <Typography
              className="text-center fw-bold fs-5"
              variant="subtitle1"
            >
              {current_question}
            </Typography>
            {!!multichoice && (
              <div className="text-center fw-bold">
                {SELECT_ALL_THAT_APPLY_TITLE}
              </div>
            )}
          </div>
          <div className="d-flex flex-row flex-wrap justify-content-center align-items-center">
            {next_choices?.map((answer, index) => {
              return (
                <StyledButton
                  className="answer-button"
                  key={index}
                  disabled={shouldDisableAnswersButton(answer)}
                  selected={
                    singleChoiceAnswer === answer ||
                    multiSelectAnswer?.some((ans) => ans === answer)
                  }
                  onClick={() => {
                    handleAnswerButtonClick(answer);
                  }}
                >
                  {answer}
                </StyledButton>
              );
            })}
          </div>
          <div
            className="answers-footer-options d-flex justify-content-center"
            id="options"
          >
            {hideBackButton && hideBackButton !== "true" && (
              <Button
                onClick={handleBackClick}
                className="button-contained button-contained-transparent"
                variant="contained"
              >
                {BACK_BUTTON}
              </Button>
            )}
            <Button
              id="nextButton"
              className={
                !!skippable || multiSelectAnswer.length
                  ? "button-contained"
                  : "disabled-button-contained"
              }
              variant="contained"
              onClick={handleNextSkipClick}
              disabled={!skippable && !multiSelectAnswer.length}
              title="Next"
            >
              {SKIP_NEXT_BUTTON}
            </Button>
          </div>
          <br />
          <br />
        </div>
      )}
    </>
  );
}

export default QuestionScreen;
